<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <b-table
            id="lottery-events-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(system_name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(schedule_time)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(actual_time)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(blocked)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(canceled)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(offered)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(odds)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(custom_odds)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(results)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(results_created)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(results_modified)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(automatic_processing)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(processed)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(process_results)="data">{{ $t(data.label) }}</template>

            <template v-slot:cell(process_results)="data">
              <span v-if="data.value">
                {{$t('Total Tickets')}}:
                <strong>
                  {{data.value.total_tickets}}
                  {{$t("tickets")}}
                </strong>
                |
                {{$t('Lost')}}:
                <strong>
                  {{data.value.tickets_lost}}
                  {{$t("tickets")}}
                </strong>
                |
                {{$t('Won')}}:
                <strong>
                  {{data.value.tickets_won}}
                  {{$t("tickets")}}
                </strong>
                |
                {{$t('Stake')}}:
                <strong>{{data.value.total_stake}}</strong>
                |
                {{$t('Stake Lost')}}:
                <strong>{{data.value.total_stake_lost}}</strong>
                |
                {{$t('Winning Amount')}}:
                <strong>{{data.value.total_win_amount}}</strong>
                {{$t('Winning Tax')}}:
                <strong>{{data.value.total_win_tax}}</strong>
                |
                <router-link :to="`/tickets?lid=${data.item.eid}`">{{$t("See Tickets")}}</router-link>
              </span>
            </template>

            <template v-slot:cell(schedule_time)="data">
              <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
            </template>
            <template v-slot:cell(actual_time)="data">
              <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
            </template>

            <template v-slot:cell(results_created)="data">
              <span v-if="data.value">{{ mom_unix(data.value).format(tableDateMedium) }}</span>
            </template>
            <template v-slot:cell(results_modified)="data">
              <span v-if="data.value">{{ mom_unix(data.value).format(tableDateMedium) }}</span>
            </template>

            <template v-slot:cell(system_name)="data">
              <router-link :to="`/lottery-systems/${data.item.esystem_id}`">{{data.value}}</router-link>
            </template>

            <template v-slot:cell(blocked)="data">
              <div v-if="data.value" class="text-center">
                <i class="fa fa-check" style="color:#cc2435" />
              </div>
            </template>

            <template v-slot:cell(canceled)="data">
              <div v-if="data.value" class="text-center">
                <i class="fa fa-check" style="color:#046bf1" />
              </div>
            </template>

            <template v-slot:cell(offered)="data">
              <div v-if="data.value" class="text-center">
                <i class="fa fa-check" style="color:#1d7c72" />
              </div>
            </template>

            <template v-slot:cell(automatic_processing)="data">
              <div v-if="data.value" class="text-center">
                <i class="fa fa-check" style="color:#1d7c72" />
              </div>
            </template>

            <template v-slot:cell(processed)="data">
              <div v-if="data.value" class="text-center">
                <i class="fa fa-check" style="color:#1d7c72" />
              </div>
            </template>

            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'lottery-events-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="bv-modal-generate" hide-footer centered>
      <template slot="modal-title">{{$t('Generate Lottery Events')}}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block" style="position:relative">
        <b-form @submit.prevent="onGenerate" autocomplete="off" ref="l">
          <b-form-group :label="$t('Select Lottery Systems')">
            <multiselect
              v-model="details.elottery_system_ids"
              :options="lotterySystemsList"
              :multiple="true"
              :close-on-select="false"
              :hide-selected="true"
              placeholder="Select lottery system"
              track-by="name"
              label="name"
            ></multiselect>
          </b-form-group>
          <b-form-group :label="$t('Date Range')">
            <date-range-picker
              :startDate="start"
              :endDate="end"
              :minDate="minDate"
              @update="updateDate"
              :locale-data="locale"
              :opens="opens"
              :timePicker="true"
              :timePicker24Hour="true"
              :timePickerSeconds="false"
              :ranges="ranges"
            />
          </b-form-group>
          <div class="text-right">
            <b-button type="submit" variant="success" class="mt-3">{{$t('Generate Events')}}</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
    <b-modal id="modal-edit" size="custom" scrollable>
      <template slot="modal-title">
        {{$t('Lottery Event')}}
        <span
          v-if="multi"
        >{{selectedIndex+1}} {{$t("of")}} {{selected.length}}</span>
      </template>
      <template slot="modal-header-close">
        <span />
      </template>
      <LotteryEvent :selectedeid="selectedeid" v-if="forceRemake" />
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button variant="secondary" @click="cancel()">{{$t('Cancel')}}</b-button>
        <b-button
          variant="success"
          @click="nextSelected"
          v-if="selectedIndex+1 < selected.length"
        >{{$t('Next')}}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { successConf, errorConf } from "@/shared/notifications";
import Multiselect from "@/components/multiselect";
import DateRangePicker from "@/components/calendar-range/DateRangePicker";
import PaginationSelect from "@/components/PaginationSelect";
import tableMixin from "@/shared/mixins/table.mixin";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";
import LotteryEvent from "./LotteryEvent";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "lotteryEvents",
  mixins: [tableMixin],
  components: {
    Multiselect,
    DateRangePicker,
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect,
    LotteryEvent
  },
  data: function() {
    return {
      tableName: "lotteryEvents",

      bulkAction: null,
      bulkActionOptions: [
        { text: "Set Results", field: "results", value: true },
        { text: "Blocked", field: "blocked", value: true },
        { text: "Unblocked", field: "blocked", value: false },
        { text: "Cancelled Yes", field: "canceled", value: true },
        { text: "Offered Yes", field: "offered", value: true },
        { text: "Offered No", field: "offered", value: false },
        { text: "Delete", field: "delete", value: true }
      ],

      filterOptions: [
        {
          field: "blocked",
          multiple: false,
          placeholder: "Blocked",
          options: [
            { name: "Blocked Events", value: true },
            { name: "Not Blocked Events", value: false }
          ],
          selected: []
        },
        {
          field: "canceled",
          multiple: false,
          placeholder: "Canceled",
          options: [
            { name: "Canceled Events", value: true },
            { name: "Not Canceled Events", value: false }
          ],
          selected: []
        },
        {
          field: "offered",
          multiple: false,
          placeholder: "Offered",
          options: [
            { name: "Offered Events", value: true },
            { name: "Not Offered Events", value: false }
          ],
          selected: []
        },
        {
          field: "processed",
          multiple: false,
          placeholder: "Processed",
          options: [
            { name: "Results Processed", value: true },
            { name: "Results Not Processed", value: false }
          ],
          selected: []
        },
        {
          field: "schedule_time",
          type: "date",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          }
        }
      ],
      isBusy: false,
      sortBy: "schedule_time",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "code", sortable: true, class: "" },
        { key: "master_code", sortable: true, class: "d-none" },
        {
          key: "esystem_id",
          label: "System Id",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        { key: "system_name", sortable: true, class: "" },
        { key: "schedule_time", sortable: true, class: "", ignore: true },
        { key: "actual_time", sortable: true, class: "d-none", ignore: true },
        { key: "blocked", sortable: true, class: "text-center", ignore: true },
        { key: "canceled", sortable: true, class: "text-center", ignore: true },
        { key: "offered", sortable: true, class: "text-center", ignore: true },
        {
          key: "automatic_processing",
          sortable: true,
          class: "text-center",
          ignore: true
        },
        {
          key: "processed",
          sortable: true,
          class: "text-center",
          ignore: true
        },
        {
          key: "process_results",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "odds", sortable: false, class: "", ignore: true },
        { key: "custom_odds", sortable: false, class: "", ignore: true },
        {
          key: "max_liability",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "custom_liability",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "results", sortable: false, class: "d-none", ignore: true },
        {
          key: "results_created",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "results_modified",
          sortable: false,
          class: "d-none",
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null,

      checkAll: false,
      selected: [],
      copy: null,
      inited: false,
      lotterySystemsList: [],
      details: {
        elottery_system_ids: [],
        date_start: moment(),
        date_end: moment().add(1, "day")
      },
      opens: "center", //which way the picker opens, default "center", can be "left"/"right"
      start: moment(),
      end: moment().add(1, "day"),
      minDate: moment().format(),
      locale: {
        format: timeFormat.datePickerLong, //format of the dates displayed
        firstDay: 1, //ISO first day of week - see moment documenations for details
        showWeekNumbers: true //show week numbers on each row of the calendar
      },
      ranges: {
        Today: [moment().startOf("day"), moment().endOf("day")],
        Tomorrow: [
          moment()
            .add(1, "day")
            .startOf("day"),
          moment()
            .add(1, "day")
            .endOf("day")
        ],
        "Next 24 hours": [moment(), moment().add(24, "hours")],
        "Next 2 days": [moment(), moment().add(2, "days")],
        "Next 7 days": [moment(), moment().add(7, "days")]
      },
      addLabel: "Generate lottery events",

      selectedeid: "",
      selectedIndex: 0,
      multi: false,
      forceRemake: true
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["lotteryEvent/endpoint"];

      return `${apiUrl}/${endpoint}s?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eid", "esystem_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  mounted() {
    this.fetchLotterySystems();
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "bv-modal-generate") {
        this.details = {
          elottery_system_ids: [],
          date_start: moment(),
          date_end: moment().add(1, "day")
        };
      }
    });
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "modal-edit") {
        this.selectedeid = "";
        this.selectedIndex = 0;
        this.multi = false;
        this.forceRemake = true;
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      }
    });
  },
  destroyed() {
    this.$root.$off("bv::modal::show");
    this.$root.$off("bv::modal::hide");
  },
  methods: {
    nextSelected() {
      this.selectedIndex += 1;
      if (this.selectedIndex < this.selected.length) {
        this.selectedeid = this.selected[this.selectedIndex];
        this.forceRemake = false;
        this.$nextTick(() => {
          this.forceRemake = true;
        });
      }
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "lottery-events-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      if (this.bulkAction.field == "results") {
        this.selectedeid = this.selected[0];
        this.selectedIndex = 0;
        this.multi = true;
        this.forceRemake = true;
        this.$bvModal.show("modal-edit");
        return;
      }

      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      if (this.bulkAction.field == "delete") {
        this.$store
          .dispatch("lotteryEvent/delete", this.selected)
          .finally(() => {
            loading.close();
            this.allSelected = false;
            this.selected = [];
            this.refresh();
          });
      }

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("lotteryEvent/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "eid") sortBy = "id";
        if (sortBy == "esystem_id") sortBy = "system_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          exactValues.push(item.selected);
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      this.$store
        .dispatch("lotteryEvent/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          resp.data.rows.forEach((item, index) => {
            if (item.process_results) {
              let res = null;
              try {
                res = JSON.parse(item.process_results);
              } catch (err) {
                // noop
              }
              resp.data.rows[index].process_results = res;
            }

            resp.data.rows[index]["_cellVariants"] = {};
            if (item.blocked) {
              resp.data.rows[index]["_cellVariants"]["blocked"] = "danger";
            }
            if (item.canceled) {
              resp.data.rows[index]["_cellVariants"]["canceled"] = "info";
            }
            if (!item.offered) {
              resp.data.rows[index]["_cellVariants"]["offered"] = "danger";
            } else {
              resp.data.rows[index]["_cellVariants"]["offered"] = "success";
            }
            if (item.processed) {
              resp.data.rows[index]["_cellVariants"]["processed"] = "success";
            }
            if (item.automatic_processing) {
              resp.data.rows[index]["_cellVariants"]["automatic_processing"] =
                "success";
            }

            if (item.flags & (1 != 0)) {
              resp.data.rows[index]["_cellVariants"]["actual_time"] = "danger";
              resp.data.rows[index]["_cellVariants"]["schedule_time"] =
                "danger";
            }
          });
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.selectedeid = item.eid;
      this.$bvModal.show("modal-edit");
      return;

      //this.$router.push("/lottery-events/" + item.eid);
    },
    fetchLotterySystems() {
      if (!this.inited) {
        this.$store
          .dispatch("lotterySystem/fetch", {
            rowsPerPage: 0,
            page: 1,
            sortBy: ["name"],
            sortDirection: ["ASC"],
            exactFields: ["active"],
            exactValues: [[true]],
            fields: ["id", "name", "schedule", "active"]
          })
          .then(resp => {
            this.lotterySystemsList = resp.data.rows.filter(
              item => item.schedule != "[]"
            );
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
          });
      }
    },
    redirect() {
      this.$bvModal.show("bv-modal-generate");
    },
    onGenerate() {
      const loadDet = this.$loading.open({
        container: this.$refs.l
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "lotteryEvent/createList";

      let tmpEvents = [];
      for (let i = 0; i < detailsData.elottery_system_ids.length; i++) {
        tmpEvents.push(detailsData.elottery_system_ids[i].eid);
      }
      if (tmpEvents.length == 0) tmpEvents = [];
      detailsData.elottery_system_ids = tmpEvents;

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Events generated";
          this.showSuccessNotification(msg);
          this.$bvModal.hide("bv-modal-generate");
          this.$root.$emit("bv::refresh::table", "lottery-events-table");
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    updateDate(value) {
      this.details.date_start = value.startDate;
      this.details.date_end = value.endDate;
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


